/**
 * @FileDescription: 采供-供应商认证
 * @Author: zhuangjinshan
 * @Date: 2026-01-27
 * @LastEditors: zhuangjinshan
 * @LastEditTime: 2026-01-27
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js';

const supplierAuthApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/material/supplier/certification';
	},
	/**
	 * @description: 获取供应商认证资料完整度
	 * @param {String} id 供应商认证id
	 */
	completenessPercent: function(id) {
		return axios.get(this.baseUrl() + "/completenessPercent/" + id);
	},
	/**
	 * @description: 平台看板统计
	 */
	platformDashboardStats: function() {
		return axios.get(this.baseUrl() + "/platformDashboardStats");
	},
	/**
	 * @description: 平台热采品牌与品类关注榜
	 */
	hotProcurementBoard: function() {
		return axios.get(this.baseUrl() + "/hotProcurementBoard");
	},
};

export default Object.assign(supplierAuthApi, BaseApi);
